import React, { useState, useRef, useEffect, useMemo, useLayoutEffect, useCallback } from 'react';
import { NavLink } from 'react-router-dom';
import './Slider.css';

export const NewsSliderClone = (props) => {
    const { cols, rows, gap, children, className, moreLink, moreTitle, initialHeight, currentWindowWidth, maxHeightCardTextValue, maxHeightCardTagsValue } = props;
    const perSlide = cols * rows;
    const slidesCount = Math.ceil(children.length / perSlide);
    let [ page, setPage ] = useState(0);
    let [ wrapperHeight, setWrapperHeight ] = useState(initialHeight || 420);
    const sliderContentRef = useRef(null);
    const slidesRefs = useMemo(() => (
        Array.from({ length: slidesCount }, () => React.createRef())
    ), [slidesCount]);

    const resizingSliderOnEvents = useCallback(() => {
        const heights = slidesRefs.map(ref => ref.current ? ref.current.offsetHeight : 0);
        // Keep the initial height until at least one slide is measurable.
        const tallestSlide = Math.max(0, ...heights);
        if (tallestSlide > 0) setWrapperHeight(tallestSlide);
    }, [slidesRefs]);

    useLayoutEffect(() => {
        resizingSliderOnEvents();
    }, [resizingSliderOnEvents, children, currentWindowWidth, maxHeightCardTextValue, maxHeightCardTagsValue]);

    useEffect(() => {
        const timer = setTimeout(resizingSliderOnEvents, 800);
        return () => clearTimeout(timer);
    }, [resizingSliderOnEvents, maxHeightCardTextValue, maxHeightCardTagsValue]);

    useEffect(() => {
        if (page >= slidesCount) setPage(Math.max(0, slidesCount - 1));
    }, [page, slidesCount]);

    const slides = Array.from({ length: slidesCount }, (_, index) => (
        children.slice(index * perSlide, (index + 1) * perSlide)
    ));

    let sliderStyle = {
        left: `calc(${-page*100}% - ${gap*page+gap}px)`,
        width: `calc(${slidesCount*100}% + ${slidesCount*gap}px)`,
    }

    let wrapperStyle = {
        padding: "0",
        height: `${wrapperHeight}px`,
    }

    let slideStyle = {
        marginLeft: gap,
        width: `calc(100% + ${gap}px)`,
    }

    const moveToPage = nextPage => {
        if (nextPage < 0 || nextPage >= slidesCount) return;
        setPage(nextPage);
    };

    const slideLeft = () => moveToPage(page - 1);
    const slideRight = () => moveToPage(page + 1);

    return(
        <div className={`rslider ${className}`}>
            <div className="rslider-wrapper" style={wrapperStyle}>
                <div className={`rslider-content count${slidesCount}`} style={sliderStyle} ref={sliderContentRef} onLoadCapture={resizingSliderOnEvents} onErrorCapture={resizingSliderOnEvents}>
                    {slides.map((slide, index)=>{
                        return(
                            <div ref={slidesRefs[index]} className={`rslide slide${index} cols${cols} last-slide-adapting`} key={index} style={slideStyle}>
                                {slide.map((element, index)=>{
                                    return(
                                        <div className={`item`} key={index}>
                                            {element}
                                        </div>
                                    );
                                })}
                            </div>
                        );
                    })}
                </div>
            </div>
            <div className="rslider-control">
                <div className={`slide-left ${page === 0}`} onClick={slideLeft}></div>
                <div className={`slide-right ${page === slidesCount-1 }`} onClick={slideRight}></div>
                {moreLink && moreTitle ? <NavLink to={moreLink} className="button more-articles">{moreTitle}</NavLink> : "" }
            </div>
        </div>
    );
}
